const auth = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default auth;